









































import Vue from 'vue';
import moment from 'moment';
import customerClient from '../../../apis';
import customerVuex from '../../../vuex/common';
import ruleType from '../../../../common/filters/ScoreRuleType';

export default Vue.extend({
  mixins: [customerVuex],
  data() {
    return {
      page: 1,
      size: 20,
      total: 0,
      data: [],
      height: 0,
      loaded: false,
      loading: false,
    };
  },
  filters: {
    ruleType,
  },
  computed: {
    styles(): any {
      return {
        height: `${this.height}px`,
      };
    },
  },
  methods: {
    loadScoreRecord() {
      this.loading = true;
      this.loaded = false;
      customerClient.getScoreDetails({
        openid: this.customerState.currentCustomer!.openid,
        page: this.page,
        size: this.size,
      }).success((r) => {
        this.data = r.data;
        this.total = r.total;
        this.loaded = true;
        this.loading = false;
      });
    },
    changePage(page: number) {
      this.page = page;
      this.loadScoreRecord();
    },
    setContentHeight() {
      this.height = window.document.body.clientHeight - 270;
    },
  },
  mounted() {
    this.loadScoreRecord();
    window.addEventListener('resize', () => {
      this.setContentHeight();
    });
    this.$nextTick(() => {
      this.setContentHeight();
    });
  },
});
